import { AxiosInstance } from 'axios';
import { WorkspaceInitDataResource } from './resources';

export default class WorkspaceInitData {
    private basePath = '/api/workspace-init-data';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get workspace init data by workspace ID
    getById = async (workspaceId: ID): Promise<WorkspaceInitDataResource> => {
        const { data } = await this.http.get(`${this.basePath}/id/${workspaceId}`);
        return data;
    };

    // Get workspace init data by workspace key
    getByKey = async (workspaceKey: string): Promise<WorkspaceInitDataResource> => {
        const { data } = await this.http.get(`${this.basePath}/key/${workspaceKey}`);
        return data;
    };
}
